import * as React from 'react'
import { IFavoriteBtnComponentProps } from "./IFavoriteBtnComponentProps";
import { IFavoriteBtnComponentState } from "./IFavoriteBtnComponentState";
import { Placeholder } from 'semantic-ui-react'
import { connect } from 'react-redux'
import like from "../../assets/images/like.png";
import likedimg from "../../assets/images/liked.png";
import * as actions from "../../actions/gifAction";
import axios from "axios";
import * as action from "../../actions/toastAction";


class FavoriteBtnComponent extends React.Component<IFavoriteBtnComponentProps, IFavoriteBtnComponentState>{

    constructor(Props: IFavoriteBtnComponentProps) {
        super(Props)
        this.state = {
            liked: false,
            loading: true
        }
    }

    componentWillMount() {

        if (this.props.isConnected) {
            axios.get(
                `https://europe-west1-ttgif-3c665.cloudfunctions.net/isFav?userid=${this.props.user.uid}&gifid=${this.props.gif.id}`
            )
                .then(result => {
                    console.log(result)
                    this.setState({
                        liked: result.data.fav,
                        loading: false
                    })
                })
            console.log('initial state: ', this.state.liked)
        }
        else {
            this.setState({
                loading: false
            })
        }
    }

    toggleFav(user, gif) {
        /* this.setState({
            loading: true
        }) */
       /* this.props.showToast("wiouuuuw !", true, () => { })
       */ axios.get(
            `https://europe-west1-ttgif-3c665.cloudfunctions.net/toggleFav?userid=${user.uid}&gifid=${gif.id}&fav=${!this.state.liked}`
        )
            .then(result => {
                console.log(result)
            })
        this.setState({
            liked: !this.state.liked,
            loading: false
        })
        console.log("new state: ", this.state.liked)
    }

    public render() {

        const { user, gif } = this.props
        const { liked } = this.state
        console.log("liked state: ", liked)
        return (
            <div>
                {
                    this.state.loading
                        ?
                        <Placeholder>
                            <Placeholder.Header image>
                                <Placeholder.Line />
                            </Placeholder.Header>
                        </Placeholder>
                        :
                        (
                            liked
                                ? <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        //this.toggleFav(user, gif)


                                        if (this.props.isConnected) {
                                            console.log('toggle area')
                                            this.toggleFav(user, gif)
                                        }
                                        else {
                                            console.log('toast area')
                                            this.props.showToast("Veuillez se connecter !", true, () => { })
                                        }
                                    }}
                                >
                                    <div className="_supImg">
                                        {
                                            liked
                                                ? <img src={likedimg} alt="like icon" />
                                                : <img src={like} alt="like icon" />
                                        }

                                    </div>
                                    <a className="_supTitle" >  Favoris</a>
                                </div>

                                : <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        if (this.props.isConnected) {
                                            console.log('toggle area')
                                            this.toggleFav(user, gif)
                                        }
                                        else {
                                            console.log('toast area')
                                            this.props.showToast("Veuillez se connecter !", true, () => { })
                                        }
                                    }}
                                >
                                    <div className="_supImg">
                                        {
                                            liked ?
                                                <img src={likedimg} alt="like icon" />
                                                :
                                                <img src={like} alt="like icon" />
                                        }

                                    </div>
                                    <a className="_supTitle" >Favoris</a>
                                </div>
                        )
                }
            </div>
        );
    }


}

function mapStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        isConnected: state.auth.authenticated
    };
}

const mapDispatchToProps = (dispatch: any, ownProps: IFavoriteBtnComponentProps) => {
    return {
        handleAddFavorite: (user, gif, cb) => dispatch(actions.addFavorite(user, gif, cb)),
        handleDeleteFavorite: (user, gif, cb) => dispatch(actions.deleteFavorite(user, gif, cb)),
        showToast: (title, show, cb) => dispatch(action.toast(title, show, cb)),
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(FavoriteBtnComponent)



// WEBPACK FOOTER //
// ./src/components/favoriteBtnComponent/FavoriteBtnComponent.tsx